import {
  Calculator,
  BookOpen,
  Globe,
  Atom,
  FlaskConical,
  type LucideProps,
} from "lucide-react";

const iconMap: Record<string, React.FC<LucideProps>> = {
  Calculator,
  BookOpen,
  Globe,
  Atom,
  FlaskConical,
};

type SubjectIconProps = LucideProps & {
  icon: string;
};

export function SubjectIcon({ icon, ...props }: SubjectIconProps) {
  const IconComponent = iconMap[icon];
  if (!IconComponent) return null;
  return <IconComponent {...props} />;
}
